'use client';

import React from 'react';
import { useScopedI18n } from '@/locales/client';

interface QuestionnaireAnswerDisplayProps {
  answers: Record<string, any>; // Les réponses du formulaire
}

const QuestionnaireAnswerDisplay: React.FC<QuestionnaireAnswerDisplayProps> = ({
  answers,
}) => {
  const tForm = useScopedI18n('formQuestionnaire.viewAnswers');

  if (!answers || Object.keys(answers).length === 0) {
    return <p className='text-gray-500'>{tForm('noAnswers')}</p>;
  }

  const alwaysShowKeys = [
    'userType',
    'leaseTermType',
    'buildingAgeUnder5',
    'tenant65Over',
    'additionalInfo',
    'buildingType',
  ];

  // Filtrer pour ne garder que les réponses non nulles ou définies
  const filteredAnswers = Object.entries(answers).filter(
    ([, value]) => value !== null && value !== undefined && value !== ''
  );

  return (
    <div className='mt-6 border-t border-gray-100 dark:border-gray-800'>
      <ul className='space-y-2 text-sm text-gray-600 dark:text-gray-300'>
        {filteredAnswers.length > 0 ? (
          filteredAnswers
            .filter(
              ([key, value]) =>
                alwaysShowKeys.includes(key) ||
                (key === 'propertyOwnership' &&
                  filteredAnswers.find(
                    ([k, v]) => k === 'userType' && v === 'landlord'
                  )) ||
                (key === 'singleOwnership' &&
                  filteredAnswers.find(
                    ([k, v]) => k === 'userType' && v === 'landlord'
                  ) &&
                  filteredAnswers.find(
                    ([k, v]) => k === 'propertyOwnership' && v === true
                  )) ||
                (key === 'spouseOwnership' &&
                  filteredAnswers.find(
                    ([k, v]) => k === 'userType' && v === 'landlord'
                  ) &&
                  filteredAnswers.find(
                    ([k, v]) => k === 'propertyOwnership' && v === true
                  ) &&
                  filteredAnswers.find(
                    ([k, v]) => k === 'singleOwnership' && v === false
                  )) ||
                (key === 'additionalInfo' && value?.trim()) ||
                (key === 'leaseDuration' &&
                  filteredAnswers.find(
                    ([k, v]) => k === 'leaseTermType' && v === 'fixed-term'
                  ))
            )
            .map(([key, value]) => {
              let labelKey = key;
              let displayValue = value;

              switch (key) {
                case 'propertyOwnership':
                  labelKey = tForm('propertyOwnership');
                  displayValue = value ? tForm('yes') : tForm('no');
                  break;
                case 'singleOwnership':
                  labelKey = tForm('singleOwnership');
                  displayValue = value ? tForm('yes') : tForm('no');
                  break;
                case 'spouseOwnership':
                  labelKey = tForm('spouseOwnership');
                  displayValue = value ? tForm('spouse') : tForm('nonSpouse');
                  break;
                case 'leaseDuration':
                  labelKey = tForm('leaseDuration');
                  displayValue = `${value} ${tForm('months')}`;
                  break;
                case 'buildingAgeUnder5':
                  labelKey = tForm('buildingAge');
                  displayValue =
                    value === 'over-5' ? tForm('over5') : tForm('under5');
                  break;
                case 'tenant65Over':
                  labelKey = tForm('tenant65Over');
                  displayValue = value ? tForm('yes') : tForm('no');
                  break;
                case 'userType':
                  labelKey = tForm('userType');
                  displayValue =
                    value === 'landlord'
                      ? tForm('landlord')
                      : value === 'tenant'
                        ? tForm('tenant')
                        : value === 'sub-tenant'
                          ? tForm('subTenant')
                          : tForm('other');
                  break;
                case 'leaseTermType':
                  labelKey = tForm('leaseTermType');
                  displayValue =
                    value === 'fixed-term'
                      ? tForm('fixedTerm')
                      : tForm('undetermined');
                  break;
                case 'buildingType':
                  labelKey = tForm('buildingType');
                  displayValue =
                    value === 'none'
                      ? tForm('none')
                      : value === 'university'
                        ? tForm('university')
                        : value === 'mobile-home'
                          ? tForm('mobileHome')
                          : tForm('lowRent');
                  break;
                case 'additionalInfo':
                  labelKey = tForm('additionalInfo');
                  break;
              }

              return (
                <li
                  key={labelKey}
                  className='grid grid-cols-2 gap-4 border-b pb-1'
                >
                  <span className='text-left font-semibold'>
                    {labelKey} {/* {tForm(labelKey)} */}
                  </span>
                  <span className='text-left'>
                    {typeof displayValue === 'object'
                      ? JSON.stringify(displayValue, null, 2)
                      : displayValue || 'N/A'}
                  </span>
                </li>
              );
            })
        ) : (
          <li className='text-gray-500'>{tForm('allEmpty')}</li>
        )}
      </ul>
    </div>
  );
};

export default QuestionnaireAnswerDisplay;
